import * as v from "valibot";

export const followCreatorsRpcContract = {
  name: "follow-creators",
  paramsSchema: v.object({
    influencerIds: v.array(v.string()),
  }),
  resultSchema: v.object({
    success: v.boolean(),
  }),
};

export type FollowCreatorsParams = v.InferInput<typeof followCreatorsRpcContract.paramsSchema>;
export type FollowCreatorsResult = v.InferOutput<typeof followCreatorsRpcContract.resultSchema>;
